export default __webpack_public_path__ + "5b0d21de55aec00318979a5150ab5dac.png";